/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getMediaBlogPost } from '../fn/media/get-media-blog-post';
import { GetMediaBlogPost$Params } from '../fn/media/get-media-blog-post';
import { getMediaBlogPostsCategories } from '../fn/media/get-media-blog-posts-categories';
import { GetMediaBlogPostsCategories$Params } from '../fn/media/get-media-blog-posts-categories';
import { listMediaBlogPosts } from '../fn/media/list-media-blog-posts';
import { ListMediaBlogPosts$Params } from '../fn/media/list-media-blog-posts';
import { MediaBlogPostResponse } from '../models/media-blog-post-response';
import { MediaBlogPostsResponse } from '../models/media-blog-posts-response';
import { MediaCategoriesResponse } from '../models/media-categories-response';
import { searchMediaBlogPosts } from '../fn/media/search-media-blog-posts';
import { SearchMediaBlogPosts$Params } from '../fn/media/search-media-blog-posts';

@Injectable({ providedIn: 'root' })
export class MediaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMediaBlogPostsCategories()` */
  static readonly GetMediaBlogPostsCategoriesPath = '/rest/media/blog-category';

  /**
   * Get all blogs categories for media.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMediaBlogPostsCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMediaBlogPostsCategories$Response(params?: GetMediaBlogPostsCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<MediaCategoriesResponse>> {
    return getMediaBlogPostsCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all blogs categories for media.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMediaBlogPostsCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMediaBlogPostsCategories(params?: GetMediaBlogPostsCategories$Params, context?: HttpContext): Observable<MediaCategoriesResponse> {
    return this.getMediaBlogPostsCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<MediaCategoriesResponse>): MediaCategoriesResponse => r.body)
    );
  }

  /** Path part for operation `listMediaBlogPosts()` */
  static readonly ListMediaBlogPostsPath = '/rest/media/blog-post/{page}/{pageSize}';

  /**
   * Get list of blog post for media, search also by category or tags, support pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listMediaBlogPosts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listMediaBlogPosts$Response(params: ListMediaBlogPosts$Params, context?: HttpContext): Observable<StrictHttpResponse<MediaBlogPostsResponse>> {
    return listMediaBlogPosts(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of blog post for media, search also by category or tags, support pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listMediaBlogPosts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listMediaBlogPosts(params: ListMediaBlogPosts$Params, context?: HttpContext): Observable<MediaBlogPostsResponse> {
    return this.listMediaBlogPosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<MediaBlogPostsResponse>): MediaBlogPostsResponse => r.body)
    );
  }

  /** Path part for operation `getMediaBlogPost()` */
  static readonly GetMediaBlogPostPath = '/rest/media/blog-post/{slug}';

  /**
   * Get single blog post for media by slug.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMediaBlogPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMediaBlogPost$Response(params: GetMediaBlogPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MediaBlogPostResponse>> {
    return getMediaBlogPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Get single blog post for media by slug.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMediaBlogPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMediaBlogPost(params: GetMediaBlogPost$Params, context?: HttpContext): Observable<MediaBlogPostResponse> {
    return this.getMediaBlogPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MediaBlogPostResponse>): MediaBlogPostResponse => r.body)
    );
  }

  /** Path part for operation `searchMediaBlogPosts()` */
  static readonly SearchMediaBlogPostsPath = '/rest/media/blog-post/search/{page}/{pageSize}/{query}';

  /**
   * Search list of blog post for media by query string, support pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchMediaBlogPosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchMediaBlogPosts$Response(params: SearchMediaBlogPosts$Params, context?: HttpContext): Observable<StrictHttpResponse<MediaBlogPostsResponse>> {
    return searchMediaBlogPosts(this.http, this.rootUrl, params, context);
  }

  /**
   * Search list of blog post for media by query string, support pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchMediaBlogPosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchMediaBlogPosts(params: SearchMediaBlogPosts$Params, context?: HttpContext): Observable<MediaBlogPostsResponse> {
    return this.searchMediaBlogPosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<MediaBlogPostsResponse>): MediaBlogPostsResponse => r.body)
    );
  }

}
